var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 18.0861C15.77 18.0861 14.22 17.2961 13.21 15.9061C12.97 15.5761 13.04 15.1061 13.37 14.8561C13.7 14.6061 14.17 14.6861 14.42 15.0161C15.15 16.0061 16.25 16.5761 17.45 16.5761C19.54 16.5761 21.25 14.8761 21.25 12.7761C21.25 10.6761 19.55 8.97605 17.45 8.97605C16.03 8.97605 14.69 9.73605 13.96 10.9461L11.31 15.3561C10.31 17.0261 8.47999 18.0561 6.53999 18.0561C3.61999 18.0561 1.23999 15.6761 1.23999 12.7561C1.23999 9.83605 3.61999 7.45605 6.53999 7.45605C8.21999 7.45605 9.76999 8.24606 10.78 9.63605C11.02 9.96605 10.95 10.4361 10.62 10.6861C10.28 10.9361 9.81999 10.8561 9.56999 10.5261C8.84999 9.55605 7.74999 8.98605 6.54999 8.98605C4.45999 8.98605 2.74999 10.6861 2.74999 12.7861C2.74999 14.8861 4.44999 16.5861 6.54999 16.5861C7.96999 16.5861 9.30999 15.8261 10.04 14.6161L12.69 10.2061C13.69 8.53605 15.52 7.50605 17.46 7.50605C20.38 7.50605 22.76 9.88605 22.76 12.8061C22.76 15.7261 20.37 18.0861 17.45 18.0861Z",
    fill: "#6D6D77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.7861C7.60457 14.7861 8.5 13.8907 8.5 12.7861C8.5 11.6816 7.60457 10.7861 6.5 10.7861C5.39543 10.7861 4.5 11.6816 4.5 12.7861C4.5 13.8907 5.39543 14.7861 6.5 14.7861Z",
    fill: "#6D6D77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.7861C18.6046 14.7861 19.5 13.8907 19.5 12.7861C19.5 11.6816 18.6046 10.7861 17.5 10.7861C16.3954 10.7861 15.5 11.6816 15.5 12.7861C15.5 13.8907 16.3954 14.7861 17.5 14.7861Z",
    fill: "#6D6D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.601c7722da0648bc67238dc56f130041.svg";
export { ForwardRef as ReactComponent };